module.exports = __webpack_public_path__ + "static/media/theology.70e74ebd.jpg";